import React, { useState } from "react";
import { Search, MapPin } from "lucide-react";

interface JobSearchBarProps {
  onSearch: (query: string) => void;
}

const JobSearchBar: React.FC<JobSearchBarProps> = ({ onSearch }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [location, setLocation] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(searchQuery);
  };

  const handleLocationSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(`${searchQuery} ${location}`.trim());
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="flex flex-col md:flex-row gap-4">
        {/* 직무 검색 */}
        <form onSubmit={handleSubmit} className="flex-1">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="직무, 회사, 기술스택으로 검색"
              className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
        </form>

        {/* 지역 검색 */}
        <form onSubmit={handleLocationSubmit} className="flex-1">
          <div className="relative">
            <MapPin className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
            <input
              type="text"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              placeholder="지역 (예: 서울, 경기)"
              className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
        </form>

        {/* 검색 버튼 */}
        <button
          onClick={() => onSearch(searchQuery)}
          className="px-8 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
        >
          검색
        </button>
      </div>

      {/* 인기 검색어 */}
      <div className="mt-4">
        <p className="text-sm text-gray-600 mb-2">인기 검색어:</p>
        <div className="flex flex-wrap gap-2">
          {[
            "React",
            "Node.js",
            "Python",
            "Java",
            "AWS",
            "Docker",
            "Kubernetes",
            "TypeScript",
          ].map((keyword) => (
            <button
              key={keyword}
              onClick={() => {
                setSearchQuery(keyword);
                onSearch(keyword);
              }}
              className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-sm hover:bg-gray-200 transition-colors"
            >
              {keyword}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default JobSearchBar;
